// useUserActivity.js
import { useEffect, useState, useRef } from 'react';

const ACTIVITY_CHANNEL = 'user-activity';

const useUserActivity = (onInactivity, inactivityThresholdMs = 10 * 60 * 1000) => {
	const [lastActivity, setLastActivity] = useState(Date.now());
	const onInactivityRef = useRef(onInactivity);

	// console.log("useUserActivity === inactivityThresholdMs =====", inactivityThresholdMs)

	// Update ref when callback changes to avoid stale closures
	useEffect(() => {
		onInactivityRef.current = onInactivity;
	}, [onInactivity]);

	useEffect(() => {
		const channel = new BroadcastChannel(ACTIVITY_CHANNEL);

		const updateActivity = () => {
			const now = Date.now();
			setLastActivity(now);

			// ✅ Broadcast activity to other tabs — reuse this channel
			channel.postMessage({ type: 'activity', timestamp: now });
		};

		// ✅ Listen for activity from other tabs
		channel.onmessage = (event) => {
			if (event.data?.type === 'activity') {
				console.log('✅ Activity received from another tab:', event.data);
				setLastActivity(event.data.timestamp);
			}
		};

		// ✅ Register activity listeners
		const events = [
			'mousemove',
			'keydown',
			'mousedown',
			'click',
			'scroll',
			'touchstart',
		];
		events.forEach(event => window.addEventListener(event, updateActivity));

		return () => {
			events.forEach(event => window.removeEventListener(event, updateActivity));
			channel.close(); // ✅ clean up correctly
		};
	}, []);

	// Inactivity checker (runs every minute)
	useEffect(() => {
		const interval = setInterval(() => {
			const now = Date.now();
			if (now - lastActivity >= inactivityThresholdMs) {
				// Use ref to avoid dependency on callback function and prevent infinite loops
				onInactivityRef.current?.();
			}
		}, 60 * 1000);

		return () => clearInterval(interval);
	}, [lastActivity, inactivityThresholdMs]); // Removed onInactivity from dependencies to prevent infinite loops

	return lastActivity;
};

export default useUserActivity;
